import Image from 'next/image';
import { useMemo } from 'react';

import { maskAddressValue } from '@/utils/format';

import { BlendPositionSide, EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const BlendTriggerDetails = ({ trigger, triggerType }: Props) => {
  const poolAddress = useMemo(() => trigger.context?.pool_address || '', [trigger.context]);
  const assetAddress = useMemo(() => trigger.context?.asset || '', [trigger.context]);

  const sideLabel = useMemo(() => {
    const side = trigger.context?.type;
    return side === BlendPositionSide.Supply ? 'Supply' : side === BlendPositionSide.Borrow ? 'Borrow' : '';
  }, [trigger.context]);

  const poolUrl = useMemo(() => {
    if (!poolAddress) return '';
    return `https://stellar.expert/explorer/public/contract/${poolAddress}`;
  }, [poolAddress]);

  // Pool, asset and side are all shown: two triggers on the same pool differ only by the last two,
  // so dropping either would make them indistinguishable in the list.
  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Pool"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <Image src="/assets/webp/stellar.webp" width={12} height={12} alt="Stellar" />
            <span>{maskAddressValue(poolAddress) ?? ''}</span>
          </div>
        }
        href={poolUrl}
      />

      <TriggerValueDetail label="Asset" value={maskAddressValue(assetAddress) ?? ''} />

      <TriggerValueDetail label="Side" value={sideLabel} />
    </div>
  );
};
